<template>
  <app-card
    title="Ferienwohnung Svenja"
    :images="images"
    :seasonalPrices="seasonalPrices"
  ></app-card>
</template>

<script>
import appartmentCardVue from '../components/appartment-card.vue'

export default {
  name: 'svenja',
  data () {
    return {
      images: [
        {
          src: 'app1/Bad.jp2',
          description: 'Badezimmer',
          thumbnail: 'app1/Bad-300.jp2'
        },
        {
          src: 'app1/Kueche-1.jp2',
          description: 'Küche',
          thumbnail: 'app1/Kueche-1-300.jp2'
        },
        {
          src: 'app1/Kueche-2.jp2',
          description: 'Küche',
          thumbnail: 'app1/Kueche-2-300.jp2'
        },
        {
          src: 'app1/Kueche-3.jp2',
          description: 'Küche',
          thumbnail: 'app1/Kueche-3-300.jp2'
        },
        {
          src: 'app1/Schlafzimmer.jp2',
          description: 'Schlafzimmer',
          thumbnail: 'app1/Schlafzimmer-300.jp2'
        },
        {
          src: 'app1/Wohnzimmer-1.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app1/Wohnzimmer-1-300.jp2'
        },
        {
          src: 'app1/Wohnzimmer-2.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app1/Wohnzimmer-2-300.jp2'
        },
        {
          src: 'app1/Wohnzimmer-3.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app1/Wohnzimmer-3-300.jp2'
        },
        {
          src: 'app1/Wohnzimmer-4.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app1/Wohnzimmer-4-300.jp2'
        }
      ],
      seasonalPrices: [
        {
          start: '2024-01-05',
          end: '2025-06-28',
          saison: 'B',
          price: 110
        },
        {
          start: '2025-06-29',
          end: '2025-09-13',
          saison: 'A',
          price: 130
        },
        {
          start: '2025-09-14',
          end: '2025-12-20',
          saison: 'B',
          price: 110
        },
        {
          start: '2025-12-21',
          end: '2026-01-03',
          saison: 'A',
          price: 130
        }
      ]
    }
  },
  components: {
    'app-card': appartmentCardVue
  },
  mounted () {
    /*
    const req = require.context('../../public/app1', true, /\.(jpg)$/i)
    req.keys().map(img => {
      if (!img.includes('-300')) {
        var imgObj = {
          src: 'app1/' + img,
          description: img,
          thumbnail: 'app1/' + img.replace('.jp2', '') + '-300.jp2'
        }
        this.images.push(imgObj)
      }
    })
    */
  }
}
</script>

<style lang="scss" scoped>
</style>
